import yup from "lib/yup-extended";
import { isValidPhone } from "lib/data/validators/phone";

export const validations = yup.object({
  name: yup.string().required("Nome é obrigatório").max(255, "O campo deve ter no máximo 255 caracteres"),

  email: yup.string().email("E-mail inválido").required("E-mail é obrigatório").max(255, "O campo deve ter no máximo 255 caracteres"),

  phone: yup
    .string()
    .test("phone format", "Informe o telefone válido", (value) =>
      isValidPhone(value || "")
    )
    .required("Telefone é obrigatório"),
});
